module.exports = __webpack_public_path__ + "img/2017-02-1024x768.ff287410.jpg";